import { SITE_URL } from "@/config/site";

const OG = (n) => `${SITE_URL}/assets/og/${n}.jpg`;
export const OG_DEFAULT = OG("og-default");

// Central per-route metadata (single source for react-helmet-async / prerender).
export const SEO = {
  home: {
    og: OG("og-default"),
    da: {
      title: "Lotusgruppen | Socialpædagogisk & koordinerende støtte til udsatte borgere",
      description:
        "Lotusgruppen tilbyder socialpædagogisk, koordinerende og beskæftigelsesrettet støtte til udsatte borgere i Danmark – i tæt samarbejde med kommuner og Kriminalforsorgen.",
    },
    en: {
      title: "Lotusgruppen | Social-pedagogical & coordinating support for vulnerable citizens",
      description:
        "Lotusgruppen provides social-pedagogical, coordinating and employment-oriented support for vulnerable citizens in Denmark, working closely with municipalities and the Probation Service.",
    },
  },
  ydelser: {
    og: OG("og-indsatser"),
    da: {
      title: "Socialpædagogiske indsatser og forløb | Lotusgruppen",
      description:
        "Lotusgruppen leverer individuelt tilrettelagte indsatser inden for afklaring, stabilisering, resocialisering, beskæftigelse og fastholdelse.",
    },
    en: {
      title: "Social-pedagogical interventions and pathways | Lotusgruppen",
      description:
        "Lotusgruppen delivers individually designed interventions within assessment, stabilisation, resocialisation, employment and retention.",
    },
  },
  indsatser: {
    og: OG("og-indsatser"),
    da: {
      title: "Indsatser og forløb | Lotusgruppen",
      description:
        "Fem tydelige forløb fra afklaring til fastholdelse. Struktureret støtte, der kan bestilles enkeltvis eller kombineres efter kommunens bestilling.",
    },
    en: {
      title: "Support pathways | Lotusgruppen",
      description:
        "Five clear pathways from assessment to retention. Structured support that can be ordered individually or combined to fit the commissioner's needs.",
    },
  },
  findforloeb: {
    og: OG("og-finder"),
    da: {
      title: "Find det rette forløb | Lotusgruppen",
      description:
        "Et vejledende værktøj, der anbefaler et relevant Lotus-forløb. Indsamler ingen personfølsomme oplysninger.",
    },
    en: {
      title: "Find the right pathway | Lotusgruppen",
      description:
        "A guiding tool that recommends a relevant Lotus pathway. It collects no sensitive personal data.",
    },
  },
  kommuner: {
    og: OG("og-kommuner"),
    da: {
      title: "Kommuner og Kriminalforsorgen | Lotusgruppen",
      description:
        "Individuelt tilrettelagte forløb med fast kontaktperson, dokumentation og tæt samarbejde omkring udsatte borgere – for kommuner og Kriminalforsorgen.",
    },
    en: {
      title: "Municipalities and the Probation Service | Lotusgruppen",
      description:
        "Individually designed pathways with a fixed contact person, documentation and close collaboration around vulnerable citizens.",
    },
  },
  akut: {
    og: OG("og-default"),
    da: {
      title: "Akutte støtteindsatser | Lotusgruppen",
      description:
        "Lotusgruppen tilbyder hurtige og afgrænsede støtteindsatser med fokus på stabilisering, koordinering og overgang til den rette videre indsats.",
    },
    en: {
      title: "Urgent Support Interventions | Lotusgruppen",
      description:
        "Lotusgruppen offers fast, defined support interventions focused on stabilisation, coordination and transition to the right next step.",
    },
  },
  udsatte: {
    og: OG("og-default"),
    da: {
      title: "Udsatte Borgere | Lotusgruppen",
      description:
        "Helhedsorienteret støtte til udsatte borgere, der med de rette rammer kan overvinde modgang og udvikle sig.",
    },
    en: {
      title: "Vulnerable Citizens | Lotusgruppen",
      description:
        "Holistic support for vulnerable citizens who, with the right framework, can overcome adversity and develop.",
    },
  },
  adhd: {
    og: OG("og-default"),
    da: {
      title: "ADHD | Lotusgruppen",
      description:
        "En omhyggelig, individuel tilgang til borgere med ADHD – fleksibilitet, tålmodighed og struktur.",
    },
    en: {
      title: "ADHD | Lotusgruppen",
      description:
        "A careful, individual approach to citizens with ADHD – flexibility, patience and structure.",
    },
  },
  autisme: {
    og: OG("og-default"),
    da: {
      title: "Autisme / ASF | Lotusgruppen",
      description:
        "Tryghed, forudsigelighed og respekt for forskelle i støtten til borgere med autisme og ASF.",
    },
    en: {
      title: "Autism / ASD | Lotusgruppen",
      description:
        "Security, predictability and respect for differences in the support for citizens with autism and ASD.",
    },
  },
  kontakt: {
    og: OG("og-default"),
    da: {
      title: "Kontakt | Lotusgruppen",
      description:
        "Kontakt Lotusgruppen for en indledende faglig dialog. Send ikke personfølsomme oplysninger gennem formularen.",
    },
    en: {
      title: "Contact | Lotusgruppen",
      description:
        "Contact Lotusgruppen for an initial professional dialogue. Do not send sensitive personal data through the form.",
    },
  },
  privatliv: {
    og: OG("og-default"),
    da: {
      title: "Privatlivspolitik | Lotusgruppen",
      description: "Sådan behandler Lotusgruppen de oplysninger, du selv indsender via kontaktformularen.",
    },
    en: {
      title: "Privacy Policy | Lotusgruppen",
      description: "How Lotusgruppen processes the information you submit through the contact form.",
    },
  },
  cookies: {
    og: OG("og-default"),
    da: {
      title: "Cookies | Lotusgruppen",
      description: "Information om cookies og teknologier på Lotusgruppen.dk.",
    },
    en: {
      title: "Cookies | Lotusgruppen",
      description: "Information about cookies and technologies on Lotusgruppen.dk.",
    },
  },
  notfound: {
    og: OG("og-default"),
    da: { title: "Siden blev ikke fundet | Lotusgruppen", description: "Siden findes ikke." },
    en: { title: "Page not found | Lotusgruppen", description: "The page does not exist." },
  },
};
